export default "__VITE_ASSET__hWCMs8Mw__"